<template>
  <div class="">
    <div>
      <b-tabs content-class="pt-1" lazy v-model="tabIndex">
        <b-tab
          v-for="(tab, index) in tabs"
          :key="index"
          @click="onTabClick(tab, index)"
          :title="tab.text"
          :active="active(index)"
          title-item-class="lisaweb"
        >
          <keep-alive>
            <component :is="selected"></component>
          </keep-alive>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Reports from "@/components/reports/generated-reports/index";
import CreateReport from "@/components/reports/generated-reports/create";
import ShortcutsAndBreadcrumbsMixin from "@/mixins/ShortcutsAndBreadcrumbsMixin";

export default {
  mixins: [ShortcutsAndBreadcrumbsMixin],
  data() {
    return {
      path: "module.REPORT",
      tabs: [
        { name: "Reports", text: "Visualizza Report" },
        { name: "CreateReport", text: "Crea Report" },
      ],
      tabsGroup: "Management",
      // breadcrumbs settings: bcs & maxLevel
      bcs: [
        {
          text: "Report",
          path: "",
          level: 0,
          disabled: true,
        },
        {
          text: "Report",
          path: "",
          level: 1,
        },
        {
          text: "Gestione Report",
          path: "",
          level: 2,
        },
        {
          text: "Visualizza Report",
          path: "module.REPORT",
          tab: `#${this.selected}`,
          level: 3,
        },
      ],
      maxLevel: 3, // use to identify the tabs level
      selected: "Reports",
      tabIndex: 0,
      // isLoading: false,
    };
  },
  components: {
    Reports,
    CreateReport,
  },
};
</script>
